import PageTitle from '../../components/page-title'
import Hero from '../../components/hero'
import MembershipsList from '../../containers/memberships/cbauto/memberships-list'

export default function HeroSection() {
  return (
    <div className='heroContainer'>
      <Hero desktopImageSrc='/images/heroes/about.jpg' opacity={1}>
        <div className='titleContainer flex flexDirectionColumn alignCenter'>
          <PageTitle>Available Memberships</PageTitle>
        </div>

        <MembershipsList />
      </Hero>
      <style jsx>{`
        .heroContainer {
          :global(.hero) {
            padding: 14.7rem 0 0;
          }
        }

        .titleContainer {
          margin: 0 auto;
          padding: 0 1.2rem;

          :global(.pageTitle) {
            text-align: center;
            color: var(--primary-bg-color);
          }

          :global(a) {
            margin: 1.8rem 0 1.5rem;
          }

          p {
            font-size: 1.8rem;
          }

          .signUp {
            color: var(--primary-color);
          }
        }

        @media (max-width: 1024px) {
          .heroContainer {
            :global(.hero) {
              padding: 2.7rem 0 0;
            }
          }

          .titleContainer {
            :global(a) {
              margin: 1.8rem 0 1rem;
            }

            p {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
